module.exports = __webpack_public_path__ + "static/media/NewJersey_DMA.5f5e2465.jpg";